import { render, staticRenderFns } from "./PurchaseDetailQuery.vue?vue&type=template&id=561fb5ab"
import script from "./PurchaseDetailQuery.vue?vue&type=script&lang=js"
export * from "./PurchaseDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports